export default __webpack_public_path__ + "static/img1-976323e9479d1801774d40c19f6ce00a.png";